import {gql} from 'graphql-request';
import {AccessRestrictionType} from '@/enums';
import {useQuery} from '@tanstack/react-query';
import {useGqlRequest} from './request';

export const ACCESS_RESTRICTION_QUERY_KEY = 'session/access-restriction';

/**
 * 이용 제한 판정 (로그인 필요). null 이면 제한 없음.
 * 접속 IP 기준이라 결과를 캐시하지 않는다 — 화면을 벗어나면 버리고(gcTime 0) 진입할 때마다 다시 조회한다.
 * enabled 를 끄면 refetch 로 필요한 시점에만 조회한다.
 */
export const useMyAccessRestriction = (userId?: string, enabled = true) => {
  const request = useGqlRequest({
    query: MY_ACCESS_RESTRICTION,
  });

  const queryFn = (): Promise<{result?: AccessRestrictionType | null}> => {
    return request({});
  };

  const select = (data?: {result?: AccessRestrictionType | null}) =>
    data?.result ?? null;

  return useQuery({
    queryFn,
    enabled: enabled && !!userId?.length,
    queryKey: [ACCESS_RESTRICTION_QUERY_KEY, userId ?? 'guest'],
    gcTime: 0,
    select,
  });
};

const MY_ACCESS_RESTRICTION = gql`
  query myAccessRestriction {
    result: myAccessRestriction
  }
`;
